module.exports = __webpack_public_path__ + "img/sys_title.1b7157cc.png";